const LOGIN_URLS = {
     LOGIN:"/auth/login",
     FORGOT_PASSWORD:"/auth/verify_reset",
     SEND_OTP:"/auth/send_otp",

};

export {
    LOGIN_URLS
}